<div class="space-y-2 py-2">
  <!-- En-tête de catégorie cliquable -->
  <button
    class="flex flex-col sm:flex-row sm:items-center sm:justify-between w-full text-left hover:bg-greyscale-50 rounded py-1 px-3 transition-colors duration-75"
    (click)="onToggleCategory()"
    (mouseenter)="onCategoryHeaderEnter()"
    (mouseleave)="onCategoryHeaderLeave()">
    <!-- Titre avec icônes - mobile: pleine largeur, desktop: flex -->
    <div class="flex items-center justify-between sm:justify-start gap-3 w-full sm:w-auto">
      <div class="flex items-center gap-3">
        <div
          class="h-4 w-4 rounded-full"
          [style.background-color]="category.baseColor"
        ></div>
        <span class="text-sm font-semibold text-greyscale-800">{{
          category.name
        }}</span>
      </div>
      <lucide-angular
        [img]="chevronRightIcon"
        class="h-3 w-3 text-greyscale-400 transition-transform duration-75"
        [class.rotate-90]="category.isExpanded"
      ></lucide-angular>
    </div>
    <!-- Valeurs - mobile: en dessous, desktop: à droite -->
    <div class="flex items-center justify-end gap-2 text-sm text-greyscale-600 tabular-nums mt-1 sm:mt-0">
      <div class="w-20 text-right">
        <span class="font-medium text-greyscale-800">{{
          formatCo2e.formatValue(category.totalImpact)
        }}</span>
        <span class="text-xs text-greyscale-500"> {{
          formatCo2e.getUnit(category.totalImpact, { perPerson: perPerson })
        }}</span>
      </div>
      <div class="w-12 text-right">
        <span class="font-medium text-primary-600"
          >{{ category.percentage }}%</span>
      </div>
    </div>
  </button>

  <!-- Éléments de la catégorie avec animation -->
  @if (category.isExpanded) {
    <div class="space-y-2 pl-7 transition-all duration-75">
      @for (item of category.items; track $index) {
        <app-impact-legend-item
          [item]="item"
          [showColorDot]="!category.itemsAreDetailsOnly"
          [perPerson]="perPerson"
          (itemHover)="onItemHover($index)"
          (itemLeave)="onItemLeave()"
        ></app-impact-legend-item>
      } @empty {
        <div class="text-xs italic text-greyscale-400">
          {{ "impact.overview.noElements" | transloco }}
        </div>
      }
    </div>
  }
</div>
